// International calling codes mapped to countries
export const COUNTRY_CALLING_CODES = [
  { code: "+93", country: "Afghanistan", iso: "AF" },
  { code: "+355", country: "Albania", iso: "AL" },
  { code: "+213", country: "Algeria", iso: "DZ" },
  { code: "+54", country: "Argentina", iso: "AR" },
  { code: "+61", country: "Australia", iso: "AU" },
  { code: "+43", country: "Austria", iso: "AT" },
  { code: "+973", country: "Bahrain", iso: "BH" },
  { code: "+880", country: "Bangladesh", iso: "BD" },
  { code: "+32", country: "Belgium", iso: "BE" },
  { code: "+55", country: "Brazil", iso: "BR" },
  { code: "+673", country: "Brunei", iso: "BN" },
  { code: "+855", country: "Cambodia", iso: "KH" },
  { code: "+237", country: "Cameroon", iso: "CM" },
  { code: "+1", country: "Canada", iso: "CA" },
  { code: "+56", country: "Chile", iso: "CL" },
  { code: "+86", country: "China", iso: "CN" },
  { code: "+57", country: "Colombia", iso: "CO" },
  { code: "+506", country: "Costa Rica", iso: "CR" },
  { code: "+385", country: "Croatia", iso: "HR" },
  { code: "+357", country: "Cyprus", iso: "CY" },
  { code: "+420", country: "Czech Republic", iso: "CZ" },
  { code: "+45", country: "Denmark", iso: "DK" },
  { code: "+20", country: "Egypt", iso: "EG" },
  { code: "+251", country: "Ethiopia", iso: "ET" },
  { code: "+358", country: "Finland", iso: "FI" },
  { code: "+33", country: "France", iso: "FR" },
  { code: "+49", country: "Germany", iso: "DE" },
  { code: "+233", country: "Ghana", iso: "GH" },
  { code: "+30", country: "Greece", iso: "GR" },
  { code: "+852", country: "Hong Kong", iso: "HK" },
  { code: "+36", country: "Hungary", iso: "HU" },
  { code: "+354", country: "Iceland", iso: "IS" },
  { code: "+91", country: "India", iso: "IN" },
  { code: "+62", country: "Indonesia", iso: "ID" },
  { code: "+98", country: "Iran", iso: "IR" },
  { code: "+964", country: "Iraq", iso: "IQ" },
  { code: "+353", country: "Ireland", iso: "IE" },
  { code: "+972", country: "Israel", iso: "IL" },
  { code: "+39", country: "Italy", iso: "IT" },
  { code: "+81", country: "Japan", iso: "JP" },
  { code: "+962", country: "Jordan", iso: "JO" },
  { code: "+7", country: "Kazakhstan", iso: "KZ" },
  { code: "+254", country: "Kenya", iso: "KE" },
  { code: "+965", country: "Kuwait", iso: "KW" },
  { code: "+856", country: "Laos", iso: "LA" },
  { code: "+961", country: "Lebanon", iso: "LB" },
  { code: "+60", country: "Malaysia", iso: "MY" },
  { code: "+52", country: "Mexico", iso: "MX" },
  { code: "+212", country: "Morocco", iso: "MA" },
  { code: "+95", country: "Myanmar", iso: "MM" },
  { code: "+977", country: "Nepal", iso: "NP" },
  { code: "+31", country: "Netherlands", iso: "NL" },
  { code: "+64", country: "New Zealand", iso: "NZ" },
  { code: "+234", country: "Nigeria", iso: "NG" },
  { code: "+47", country: "Norway", iso: "NO" },
  { code: "+968", country: "Oman", iso: "OM" },
  { code: "+92", country: "Pakistan", iso: "PK" },
  { code: "+507", country: "Panama", iso: "PA" },
  { code: "+51", country: "Peru", iso: "PE" },
  { code: "+63", country: "Philippines", iso: "PH" },
  { code: "+48", country: "Poland", iso: "PL" },
  { code: "+351", country: "Portugal", iso: "PT" },
  { code: "+974", country: "Qatar", iso: "QA" },
  { code: "+40", country: "Romania", iso: "RO" },
  { code: "+7", country: "Russia", iso: "RU" },
  { code: "+966", country: "Saudi Arabia", iso: "SA" },
  { code: "+65", country: "Singapore", iso: "SG" },
  { code: "+27", country: "South Africa", iso: "ZA" },
  { code: "+82", country: "South Korea", iso: "KR" },
  { code: "+34", country: "Spain", iso: "ES" },
  { code: "+94", country: "Sri Lanka", iso: "LK" },
  { code: "+46", country: "Sweden", iso: "SE" },
  { code: "+41", country: "Switzerland", iso: "CH" },
  { code: "+886", country: "Taiwan", iso: "TW" },
  { code: "+255", country: "Tanzania", iso: "TZ" },
  { code: "+66", country: "Thailand", iso: "TH" },
  { code: "+90", country: "Turkey", iso: "TR" },
  { code: "+256", country: "Uganda", iso: "UG" },
  { code: "+380", country: "Ukraine", iso: "UA" },
  { code: "+971", country: "United Arab Emirates", iso: "AE" },
  { code: "+44", country: "United Kingdom", iso: "GB" },
  { code: "+1", country: "United States", iso: "US" },
  { code: "+598", country: "Uruguay", iso: "UY" },
  { code: "+84", country: "Vietnam", iso: "VN" },
  { code: "+263", country: "Zimbabwe", iso: "ZW" },
];

export const getCallingCodeForCountry = (countryName) => {
  const entry = COUNTRY_CALLING_CODES.find(
    (c) => c.country.toLowerCase() === countryName?.toLowerCase()
  );
  return entry ? entry.code : "+1";
};
